import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../section-components/AuthContext";

const LoginAgent = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      if (!navigator.onLine) {
        throw new Error("Vous êtes hors ligne");
      }

      const controller = new AbortController();
      const timeout = 8000;
      const timeoutId = setTimeout(() => controller.abort(), timeout);

      const response = await fetch("https://keurgui-backend-kjour.ondigitalocean.app/api/loginagent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: email.trim(),
          password: password.trim(),
        }),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.message ||
            `Erreur serveur (${response.status}: ${response.statusText})`
        );
      }

      const data = await response.json();

      if (!data.agent) {
        throw new Error("Réponse serveur invalide");
      }

      // Sauvegarde de l'agent dans le contexte et localStorage
      login(data.agent);

      // 🔥 Récupérer les initiales du nom de l'agent
      const initials = data.agent.agentName
        ?.split(" ")
        .map((n) => n.charAt(0).toUpperCase())
        .slice(0, 2)
        .join("");

      // ✅ Stocker dans localStorage
      if (initials) {
        localStorage.setItem("agentInitial", initials);
      }

      navigate(`/my-account/${data.agent.id}`);
    } catch (err) {
      let errorMessage = "Erreur technique";

      if (err.name === "AbortError") {
        errorMessage = "Le serveur ne répond pas - temps dépassé";
      } else if (err.message.includes("Failed to fetch")) {
        errorMessage =
          "Impossible de contacter le serveur. Vérifiez :\n" +
          "- Votre connexion internet\n" +
          "- Que l'URL est correcte\n" +
          "- Les éventuels bloqueurs de contenu";
      } else {
        errorMessage = err.message;
      }

      setError(errorMessage);
      console.error("Détails erreur:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-tabbs">
          <h5>Connexion</h5>
        </div>

        <div className="login-content">
          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-group">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Courriel"
                required
              />
            </div>
            <div className="input-group">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mot de passe"
                required
              />
            </div>
            <div style={{ textAlign: "right", marginTop: "5px" }}>
  <Link
    to="/forgot-password-agent"
    style={{
      fontSize: "13px",
      color: "#007bff",
      textDecoration: "none",
    }}
  >
    Mot de passe oublié ?
  </Link>
</div>
            <button
              type="submit"
              disabled={loading}
              className="theme-btn-1 btn btn-block"
              style={{
                width: "360px",
                height: "40px",
                padding: "10px",
                background: "linear-gradient(135deg, #007bff, #0056b3)",
                color: "white",
                fontSize: "14px",
                fontWeight: "bold",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.3s ease-in-out",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {loading ? <div className="spinner"></div> : "Connexion avec mon courriel"}
            </button>
            {error && <p className="error-message">{error}</p>}
          </form>
        </div>
      </div>

      <div
        className="login-footer-text mt-20"
        style={{ textAlign: "center", fontSize: "14px", color: "#333" }}
      >
        <p>
          <strong>Connectez-vous à votre compte</strong>
        </p>
        <p>L’accès aux informations est réservé aux courtiers agréés...</p>
        <p>
          En accédant à l’Espace Keurgui, vous acceptez nos{" "}
          <Link to="">Conditions d’utilisation</Link> et notre{" "}
          <Link to="">Politique de confidentialité</Link>.
        </p>
      </div>
    </div>
  );
};

export default LoginAgent;
